"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PartnerContainerHooks_1 = require("./PartnerContainerHooks");
class Resolver {
    static resolve(serviceToken) {
        if (PartnerContainerHooks_1.partnerContainer === undefined || PartnerContainerHooks_1.partnerContainer === null) {
            return null;
        }
        return PartnerContainerHooks_1.partnerContainer.ResolveService(serviceToken);
    }
}
class ServiceFactory {
    constructor(angularObj) {
        if (angularObj !== undefined && angularObj !== null) {
            this._angular = angularObj;
        }
    }
    getServiceInstance(serviceToken) {
        let service = Resolver.resolve(serviceToken);
        if (service !== undefined && service !== null) {
            return service;
        }
        let angularJsDI = this.GetAngularJsDI();
        if (angularJsDI !== undefined && angularJsDI !== null) {
            service = angularJsDI.get(serviceToken);
            if (service !== undefined && service !== null && service.constructor.name === serviceToken) {
                return service;
            }
        }
        return null;
    }
    GetAngularJsDI() {
        if (this._angular === undefined || this._angular === null) {
            if (angular === undefined || angular === null) {
                return null;
            }
            this._angular = angular;
        }
        return this._angular.element(document.body).injector();
    }
}
exports.ServiceFactory = ServiceFactory;
exports.FxpServiceFactory = new ServiceFactory();
